import { Button, ButtonRow } from '@ksyos/design-system';
import { useNavigate } from '@ksyos/router';
import { useState } from 'react';
import { getSelectedLanguage } from '@frontend/translate';
import { useAccountRequestContext } from '@frontend/utils/hooks/useAccountRequestContext';
import { AccountRequestRejectionReasonModal } from './AccountRequestRejectionReasonModal';

export function AccountRequestReviewButtons() {
    const { approveAccountRequest, getScrollToId } = useAccountRequestContext();
    const navigate = useNavigate();

    const language = getSelectedLanguage();

    const [showRejectionReasonModal, setShowRejectionReasonModal] = useState(false);

    return (
        <>
            <ButtonRow
                justify="right"
                sx={{ paddingTop: '2.5rem' }}
            >
                <>
                    <Button
                        color="danger"
                        iconLeft="close"
                        onClick={() => setShowRejectionReasonModal(true)}
                        variant="solid"
                    >
                        {language.accountRequest.reject}
                    </Button>
                    <Button
                        color="success"
                        iconLeft="closed"
                        onClick={handleApproverRequest}
                        variant="solid"
                    >
                        {language.accountRequest.approve}
                    </Button>
                </>
            </ButtonRow>
            <AccountRequestRejectionReasonModal
                isOpen={showRejectionReasonModal}
                onCancel={() => setShowRejectionReasonModal(false)}
            />
        </>
    );

    async function handleApproverRequest() {
        const approvedAccountRequest = await approveAccountRequest();

        const scrollToId = getScrollToId(approvedAccountRequest);

        navigate(`/organizations/${approvedAccountRequest.organizationId}/view#${scrollToId}`);
    }
}
